module.exports = __webpack_public_path__ + "static/scale-model-of-vibrancy-guitar-statue-in-austin-texas-6806ea8749248b3e32056e28f1b3f1bf.png";